export default __webpack_public_path__ + "static/media/modulePregnancy-fixed.c2e71644.mp4";